import Strawberry from "../common/image/Strawberry.png";
import Lemon from "../common/image/Lemon.png";
import Grape from "../common/image/Grape.png";
import Peach from "../common/image/Peach.png";

export const RESULT_IMAGES = [Strawberry, Lemon, Grape, Peach];
